import React from "react";
import { Link } from "react-router-dom";

import { useFetch } from "../../Hooks/useFetch";
import { BASE_URL } from "../../Store/Action";
import { CampaignCard, Campaign } from "./CampaignCard";
import clsx from "clsx";
import {useThemeAsset} from '@/Hooks/useThemeAsset'
import banner from "../../assets/cardPopularity.svg";
import { ChevronRightCircle } from "lucide-react";

const weuBeuaty = import.meta.env.VITE_APP_THEME
const Popularity = ({ className }: { className?: string }) => {
  const {logo, grayscaleLogo} = useThemeAsset()
  let theme = weuBeuaty == "weubeauty" ? "beauty" : "all" 
  const { fetchData } = useFetch<{ data: Campaign[] }>({
    url: `${BASE_URL}/user/slot/campaign?type=total_apply&size=6&page=1&category=${theme}`,
    method: "GET",
  });
  // console.log(fetchData);
  return (
    <div className={className}>
      <div className="flex justify-between">
        <div className="text-xl mb-3">
          <span className="text-[#1D2C59]">인기</span>
          <span className="text-[#282A35] ml-1">캠페인</span>
        </div>
        <Link to={'/detailcategory/가게'}>
          <ChevronRightCircle width={26} height={26}/>
        </Link>
      </div>
      <div className="overflow-x-auto hide-scrollbar my-2">
        <div className="flex gap-x-3 xl:gap-x-9 xl:mt-5">
          {/* Banner dimasukkan ke dalam scroll container */}
          {/* <div className={clsx(grayscaleLogo ? `hidden` : `shrink-0 w-[110px] sm:w-[150px] xl:w-[200px]`)}>
            <img
              src={banner}
              alt="banner"
              className="w-full h-full object-cover rounded-lg"
            />
          </div> */}

          {fetchData?.data?.map((campaign) => (
            <div
              key={campaign.id}
              className="shrink-0 w-[110px] sm:w-[150px] xl:w-[200px]"
            >
              <CampaignCard campaign={campaign} lastCampaignRef={null} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Popularity;
